import React from 'react';
import { useHistory } from 'react-router';
import './AboutMe.css';
import avatar from '../../../images/avatar/avatar2.jpg';
import facebook from '../../../images/social/facebook.png';
import linkedIn from '../../../images/social/linkedin.png';
import email from '../../../images/social/mail.png';
import twitter from '../../../images/social/twitter.png';
import github from '../../../images/social/github.png';

const AboutMe = () => {
    const history = useHistory();
    return (
        <div id="about-me" className="App container-about">
            <div className="center container">
                <h1 className="h1-sec">About Me</h1>
                <hr className="hr-sec" />
                <br />
                <br />
                <br />
                <img onDoubleClick={() => history.push('/admin')} className="resized-avatar" src={avatar} alt="" />
                <br />
                <h2>NAIM MORSHED</h2>
                <h5>Full Stack Web Developer</h5>
                <div>
                    <p className="text-justify container p-4">I have extensive knowledge of recognized technical standards and am familiar with modern web build practices in developing and designing user interfaces. Currently I am adapted with ReactJS development along with backend support. I am always eager to learn new technologies and adapt with automation. If you fell curious about me take a look at my work or get in touch!</p>
                </div>
                <div className="social">
                    <a href="https://www.facebook.com/naim.morshed.1/" target="_blank"><img src={facebook} alt=""/></a>
                    <a href="https://www.linkedin.com/in/naim-morshed-3a30b8178/" target="_blank"><img src={linkedIn} alt=""/></a>
                    <a href="mailto:morshed.naim13@gmail.com" target="_blank"><img src={email} alt=""/></a>
                    <a href="https://twitter.com/naimpritom" target="_blank"><img src={twitter} alt=""/></a>
                    <a href="https://github.com/NaimMorshed?tab=repositories" target="_blank"><img src={github} alt=""/></a>
                </div>

            </div>
        </div>
    );
};

export default AboutMe;